import { registerPlugin } from "@capacitor/core"

import type { TTLockPlugin } from "./definitions"

const TTLock = registerPlugin<TTLockPlugin>("TTLock")

export type * from "./definitions"
export { TTLock }
